import React from "react";
import { ExternalLink } from "lucide-react";
import { useB2BTranslation } from "../../B2BShared/hooks/useB2BTranslation";
import B2BBackButton from "../../B2BShared/B2BBackButton";
import { B2B_EVENTS, isEventExpired } from "../../B2BShared/constants/events";
import "./B2BDashboardEvents.css";

const B2BDashboardEvents: React.FC = () => {
  const { tEvents } = useB2BTranslation();

  // Get the first event (or you can extend this to show multiple events)
  const event = B2B_EVENTS[0] || null;
  
  if (!event) {
    return (
      <div className="dashboard-events-container">
        <div className="dashboard-events-header">
          <B2BBackButton
            to="/gcb/dashboard"
            translationKey="events.backToDashboard"
            variant="orange"
            size="medium"
            namespace="b2b"
          />
          <div className="events-header-content">
            <h1>{tEvents("title")}</h1>
          </div>
        </div>
        <div className="event-details-container">
          <p>Нет доступных мероприятий</p>
        </div>
      </div>
    );
  }
  
  const eventIsExpired = isEventExpired(event.eventDate);

  return (
    <div className="dashboard-events-container">
      {/* Header */}
      <div className="dashboard-events-header">
        <B2BBackButton
          to="/gcb/dashboard"
          translationKey="events.backToDashboard"
          variant="orange"
          size="medium"
          namespace="b2b"
        />
        <div className="events-header-content">
          <h1>{tEvents("title")}</h1>
        </div>
      </div>

      {/* Event Details */}
      <div className="event-details-container">
        <div className="event-card featured">
          <div className="event-header">
            <span className="event-category">{event.category}</span>
            <span className="event-price">{event.price}</span>
          </div>

          <h2 className="event-title">{event.title}</h2>
          <p className="event-description">{event.description}</p>

          <div className="event-content">
            <div className="event-section">
              <h3>Мы обсудим:</h3>
              <ul className="topics-list">
                {event.topics.map((topic, index) => (
                  <li key={index}>{topic}</li>
                ))}
              </ul>
            </div>

            <div className="event-section">
              <h3>Спикеры:</h3>
              <ul className="speakers-list">
                {event.speakers.map((speaker, index) => (
                  <li key={index}>{speaker}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="event-actions">
            {eventIsExpired ? (
              <button
                disabled
                className="register-button register-button-disabled"
              >
                Мероприятие завершено
              </button>
            ) : (
              <a
                href={event.registrationLink}
                target="_blank"
                rel="noopener noreferrer"
                className="register-button"
              >
                <ExternalLink size={16} />
                Зарегистрироваться
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2BDashboardEvents;

